import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  "page-Institution": "",
  class: /*#__PURE__*/_normalizeClass([
      'w-full h-full',
      'flex justify-center',
      'bg-white',
      'p-2 pt-16 pb-4',
      'overflow-y-auto'
    ])
}
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass([
        'w-2/3 md:w-full'
      ])
}
const _hoisted_3 = {
  class: /*#__PURE__*/_normalizeClass([
      ])
}
const _hoisted_4 = {
  class: /*#__PURE__*/_normalizeClass([
          'flex justify-between',
        ])
}
const _hoisted_5 = {
  class: /*#__PURE__*/_normalizeClass([
        'mt-5',
        'pb-16'
      ])
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BasicHeadline = _resolveComponent("BasicHeadline")
  const _component_BasicImage = _resolveComponent("BasicImage")
  const _component_BasicText = _resolveComponent("BasicText")
  const _component_SnippetTree = _resolveComponent("SnippetTree")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_BasicHeadline, {
            text: $props.abstract.name,
            size: 'sm',
            class: _normalizeClass([
          ])
          }, null, 8, ["text"]),
          _createVNode(_component_BasicImage, {
            src: $props.abstract.thumbnail,
            class: _normalizeClass([
            'max-w-32 max-h-32',
          ])
          }, null, 8, ["src"])
        ]),
        _createVNode(_component_BasicText, {
          text: 'Short description',
          size: 'sm',
          class: _normalizeClass([
          'mt-4'
        ])
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tree.children, (c, key, index) => {
          return (_openBlock(), _createBlock(_component_SnippetTree, {
            tree: c,
            key: key,
            prefix: '',
            depth: 1,
            index: index
          }, null, 8, ["tree", "index"]))
        }), 128))
      ])
    ])
  ]))
}